import { render, staticRenderFns } from "./WPColorPicker.vue?vue&type=template&id=7e2d59bc"
import script from "./WPColorPicker.vue?vue&type=script&lang=ts"
export * from "./WPColorPicker.vue?vue&type=script&lang=ts"
import style0 from "./WPColorPicker.vue?vue&type=style&index=0&id=7e2d59bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports